import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IncidentAboutDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-incident-about',
  templateUrl: './incident-about.component.html',
  styleUrls: ['./incident-about.component.scss']
})
export class IncidentAboutComponent implements OnChanges {
  
  incidentAboutForm: FormGroup;
  incidentAboutFormArray: FormGroup;
  control = new FormControl();
  @Input() incidentAbouts: IncidentAboutDto[];
  @Input() routeAnimationsElements: any;
  @Output() incidentAbout = new EventEmitter<IncidentAboutDto[]>()
  @Output() deleteIncidentAboutEvent = new EventEmitter<any>()

    selectedIncidentAbout: any;
    filteredDelete: Array<any> = [];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createIncidentAboutForm();
    }

    createIncidentAboutForm() {
      this.incidentAboutForm = this.fb.group({
        AboutName: ['', Validators.required],
        AboutDescription: [''],
        id: null
        });
        this.incidentAboutFormArray = this.fb.group({ IncidentAbouts: this.fb.array([])
          });
        this.setIncidentAbout();
    }

  // method to display IncidentAbout
  setIncidentAbout() {
    const control  = this.incidentAboutFormArray.controls.IncidentAbouts as FormArray;
    this.incidentAbouts.forEach( e => {
      control.push(
        this.fb.group({
          AboutName: e.AboutName,
          AboutDescription: e.AboutDescription,
          id: e.id
        })
      );
    });
  }


  // method to add IncidentAbout
  addIncidentAbout(value: IncidentAboutDto) {
    const control  = this.incidentAboutFormArray.controls.IncidentAbouts as FormArray;
    control.insert(0,
          this.fb.group({
            AboutName: value.AboutName,
            AboutDescription: value.AboutDescription,
            id: null
          })
       );
  }

  selectIncidentAbout(value) {}

  // method to delete IncidentAbout from arrary list
  deleteIncidentAbout(index, value) {
    console.log("Checking Ids...", value);
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.incidentAboutFormArray.controls.IncidentAbouts as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.incidentAbouts.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.incidentAbouts[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: IncidentAboutDto) {
    if(this.incidentAboutForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.incidentAboutFormArray.get('IncidentAbouts')['controls'][this.selectedIndex].patchValue({...formValue});
    } else {
      this.addIncidentAbout(formValue);
    }
    this.selectedIndex = null;
    this.incidentAboutForm.reset()
  }

  onEdit(index, value: IncidentAboutDto) {
    this.selectedIndex = index;
    this.incidentAboutForm.patchValue({...value});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.incidentAboutForm.reset();
  }

  onSubmit(formValue: IncidentAboutDto[]) {
  this.incidentAbout.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteIncidentAboutEvent.emit(this.filteredDelete);
  }
  }
  

}




